<template>
  <el-main>
    <el-tabs type="border-card" v-model="actTab">
      <el-tab-pane name="0">
        <span slot="label">
          <img class="icon_openai icon_openai_margin" src="../assets/img/footer_btn2.png" alt="" />
          <span>{{this.$store.state.sysInit.html_const.cons_273_generative_ai}}</span>
          <span>{{azureOpenAiSearchStatus}}</span> 
        </span>
        <OpenAiTab/>
      </el-tab-pane>
      <el-tab-pane
        v-for="(collection, idx) in this.$store.state.discovery.collections"
        :key="collection.collection_id"
        :name="(idx+1).toString()"
      >
        <span slot="label">
          <!-- <i class="fa-thin fa-star"></i> -->
          <!-- <font-awesome-icon icon="fa-thin fa-star" /> -->
          <!-- <img class="icon_openai" src="https://cache.globalcatalog.cloud.ibm.com/api/v1/76b7bf22-b443-47db-b3db-066ba2988f47/artifacts/cache/d63afb5a0d6e80a1bd80d95c0b9e7c8a-public/WatsonDiscovery.svg" alt="" /> -->
          <!-- <font-awesome-icon v-if="idx==0" class="icon_openai" :icon="['far', 'star']" /> -->
          <img v-if="collection.name=='MAXIMO_SOLUTIONS'" class="icon_openai " src="../assets/img/maximo_solution.svg" alt="" />
          <img v-if="collection.name=='Service Requests'" class="icon_openai " src="../assets/img/maximo_service_request.svg" alt="" />
          <!-- <font-awesome-icon v-if="idx==1" class="icon_openai" :icon="['far', 'square-check']" /> -->
          <font-awesome-icon v-if="collection.name =='KNOWLEDGE'" class="icon_openai" :icon="['far', 'folder']" />
          <font-awesome-icon v-if="collection.name =='RECOMMEND'" class="icon_openai" :icon="['far', 'heart']" />
          <!-- <font-awesome-icon v-if="idx==4" class="icon_openai" :icon="['far', 'clipboard']" /> -->
          <img v-if="collection.name =='TICKET_LOG'" class="icon_openai " src="../assets/img/redmine.png" alt="" />
          <!-- <i class="el-icon-s-ticket"></i> -->
          <!-- <i class="fa-sharp fa-light fa-face-saluting"></i> -->
          <span
            >{{ collection.name }}<span>{{ collection.searchInfo }}</span></span
          >
        </span>

        <el-table
          :data="collection.dataList"
          class="result discovery_search"
          :show-header="false"
          :empty-text="$store.state.sysInit.html_const.cons_219_no_data"
          v-loading="collection.loading"
          height="100%"
          @row-dblclick="
            (row, column, e) => documentClick(row, column, e, collection)
          "
          :cell-class-name="rowClass"
          v-if="collection.name =='KNOWLEDGE' || collection.name =='RECOMMEND'
          || collection.name =='TICKET_LOG' || collection.name=='MAXIMO_SOLUTIONS' "
        >
          <el-table-column align="center" width="20">
            <template slot-scope="scope">
              <span :class="{ 'show-class': !scope.row.pinFlag }"
                ><img class="img" src="./../assets/img/pin.png"
              /></span>
            </template>
          </el-table-column>
          <el-table-column class-name="title">
            <template slot-scope="scope">
              <div style="margin-top: 5px !important"></div>
              <a
                :class="!scope.row.data.noteslink ? 'none-url' : ''"
                @click="linkClick(scope.row)"
                @click.stop="deleteVisible = true"
                ><p v-html="scope.row.data.notestitle"></p></a
              >
              <div id="doc2" ref="ref_doc2">
                <div :class="[scope.row.notesDocFlg ? 'notesdoc-tip' : (scope.row.showAllflag ? 'notesdoc_disable': 'notesdoc')]"
                    :id="scope.row.document_id"
                    ref="ref_doc1">
                  <p v-html="scope.row.data.notesdoc.replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>')"></p>

                  <!-- <div class="imgContent" v-if="scope.row.data.notesimgs && scope.row.data.notesimgs !=''">
                    <div v-for="(i, id) in scope.row.data.notesimgs.split(',')" :key="id" class="imgItem">
                      <img :src="i" class="discovery_csv"/>
                    </div>
                  </div> -->
                </div>
               

                <el-button
                  type="text"
                  v-if="scope.row.notesDocFlg"
                  @click="changeDoc(scope.row, false)"
                  class="show_all"
                  >一部を表示</el-button
                >
                <el-button
                  v-show="!scope.row.showAllflag"
                  id="showAll"
                  type="text"
                  v-else
                  @click="changeDoc(scope.row, true)"
                  :class="[
                    scope.row.showAllflag ? 'disable_show_all' : 'show_all',
                  ]"
                  :disabled="scope.row.showAllflag"
                  >すべて表示</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="170">
            <template slot-scope="scope">
              <p>
                {{ $store.state.sysInit.html_const.cons_247_score }}
              </p>
              <p
                style="background-color: transparent; border: 0"
                :disabled="judgeLine(scope.row)"
              ></p>
              <div class="score-block">
                <div class="score-div">
                  <span>{{ getConfidence(collection.dataList, scope.row.result_metadata.confidence) }}%</span>
                </div>
                <div class="score-progress">
                  <div class="score-full-div" 
                    :style="{ 'width' : getConfidence(collection.dataList, scope.row.result_metadata.confidence) + '%' }"></div>
                </div>
              </div>
              <p>
                <el-button
                  type="success"
                  :disabled="scope.row.evaluate"
                  @click="evaluate(scope.row, collection, 'good', 'KRT')"
                  class="rate is-circle"
                  :class="{ hideEvaluate: scope.row.flag == 'bad' }"
                  icon="good"
                  @click.stop="deleteVisible = true"
                >
                </el-button>
                <el-button
                  type="danger"
                  :disabled="scope.row.evaluate"
                  @click="evaluate(scope.row, collection, 'bad', 'KRT')"
                  class="rate is-circle"
                  :class="{ hideEvaluate: scope.row.flag == 'good' }"
                  icon="bad"
                  @click.stop="deleteVisible = true"
                >
                </el-button>
                <span>
                <el-button
                v-if="scope.row.saveFlg"
                class="rate is-circle btn-trans"
                :disabled="scope.row.saveFlg"
                :class="{'no-click':scope.row.saveFlg }"
                >
                <i class="el-icon-dis-save-before i-trans "/>
                </el-button>

                <el-button
                v-else
                class="rate is-circle btn-trans"
                 @click="disSave(scope.row, 'KRT')"
                >
               
                <i class="el-icon-dis-save-before i-trans"/>
                </el-button>
                </span>
              
                <span v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'">
                   <el-button
                v-if="scope.row.copyFlg"
                class="rate is-circle btn-trans"
                :disabled="scope.row.copyFlg"
                :class="{'no-click':scope.row.copyFlg }"
                >
                <i class="el-icon-dis-copy-before i-trans"/>
                </el-button>

                <el-button
                v-else
                class="rate is-circle btn-trans"
                 @click="disCopy(scope.row, 'KRT')"
                >
                <i class="el-icon-dis-copy-before i-trans"/>
                </el-button>
                </span>
              
              </p>
            </template>
          </el-table-column>
        </el-table>

         <el-table
          :data="collection.dataList"
          class="result discovery_search"
          :show-header="false"
          :empty-text="$store.state.sysInit.html_const.cons_219_no_data"
          v-loading="collection.loading"
          height="100%"
          @row-dblclick="
            (row, column, e) => documentClick(row, column, e, collection)
          "
          :cell-class-name="rowClass"
          v-if="collection.name=='Solutions'|| collection.name=='Service Requests'"
        >
          <el-table-column align="center" width="20">
            <template slot-scope="scope">
              <span :class="{ 'show-class': !scope.row.pinFlag }"
                ><img class="img" src="./../assets/img/pin.png"
              /></span>
            </template>
          </el-table-column>
          <el-table-column class-name="title">
            <template slot-scope="scope">
              <div style="margin-top: 5px !important"></div>
              <a
                :class="''"
                @click="linkClick2(scope.row, scope.row.type)"
                @click.stop="deleteVisible = true"
                >
                scope.row.title
                 <!-- <p v-html="scope.row.title.constructor == Array? 
                getHighlightTextHtml(scope.row.title[0], 'title', scope.row.highlight):
                getHighlightTextHtml(scope.row.title, 'title', scope.row.highlight)"></p> -->
                </a
              >
              <div >
                <div :id="scope.row.document_id"
                  :class="[scope.row.notesDocFlg ? 'notesdoc-tip' : (scope.row.showAllflag ? 'notesdoc_disable': 'notesdoc')]">
                  <div v-for="(c,index) in scope.row.sequence" :key="index">
                    <p v-html="('<span style=\'font-weight: bold \'>' + scope.row.i18n[c] + ':</span><br>' + getHighlightTextHtml(scope.row.content[c], 'content.' + c, scope.row.highlight) ) .replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>')"></p>
                  </div>
                </div>
                
                <el-button
                  type="text"
                  v-if="scope.row.notesDocFlg"
                  @click="changeDoc(scope.row, false)"
                  class="show_all"
                  >一部を表示</el-button
                >
                <el-button
                  v-show="!scope.row.showAllflag"
                  id="showAll"
                  type="text"
                  v-else
                  @click="changeDoc(scope.row, true)"
                  :class="[
                    scope.row.showAllflag ? 'disable_show_all' : 'show_all',
                  ]"
                  :disabled="scope.row.showAllflag"
                  >すべて表示</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="170">
            <template slot-scope="scope">
              <p>
                {{ $store.state.sysInit.html_const.cons_247_score }}
              </p>
              <p
                style="background-color: transparent; border: 0"
                :disabled="judgeLine(scope.row)"
              ></p>
              <div class="score-block">
                <div class="score-div">
                  <span>{{ getConfidence(collection.dataList, scope.row.result_metadata.confidence) }}%</span>
                </div>
                <div class="score-progress">
                  <div class="score-full-div" 
                    :style="{ 'width' : getConfidence(collection.dataList, scope.row.result_metadata.confidence) + '%' }"></div>
                </div>
              </div>
              <p>
                <el-button
                  type="success"
                  :disabled="scope.row.evaluate"
                  @click="evaluate(scope.row, collection, 'good', 'Maximo')"
                  class="rate is-circle"
                  :class="{ hideEvaluate: scope.row.flag == 'bad' }"
                  icon="good"
                  @click.stop="deleteVisible = true"
                >
                </el-button>
                <el-button
                  type="danger"
                  :disabled="scope.row.evaluate"
                  @click="evaluate(scope.row, collection, 'bad', 'Maximo')"
                  class="rate is-circle"
                  :class="{ hideEvaluate: scope.row.flag == 'good' }"
                  icon="bad"
                  @click.stop="deleteVisible = true"
                >
                </el-button>
                <span>
                <el-button
                v-if="scope.row.saveFlg"
                class="rate is-circle btn-trans"
                :disabled="scope.row.saveFlg"
                :class="{'no-click':scope.row.saveFlg }"
                >
                <i class="el-icon-dis-save-before i-trans "/>
                </el-button>

                <el-button
                v-else
                class="rate is-circle btn-trans"
                 @click="disSave(scope.row, 'Maximo')"
                >
               
                <i class="el-icon-dis-save-before i-trans"/>
                </el-button>
                </span>
              
                <span v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'">
                   <el-button
                v-if="scope.row.copyFlg"
                class="rate is-circle btn-trans"
                :disabled="scope.row.copyFlg"
                :class="{'no-click':scope.row.copyFlg }"
                >
                <i class="el-icon-dis-copy-before i-trans"/>
                </el-button>

                <el-button
                v-else
                class="rate is-circle btn-trans"
                 @click="disCopy(scope.row, 'Maximo')"
                >
                <i class="el-icon-dis-copy-before i-trans"/>
                </el-button>
                </span>
              
              </p>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- <el-tab-pane name="6">
        <span slot="label">
          <i class="el-icon-search" style="margin-right:5px"></i>
          <span>{{$store.state.discovery.documentSearchCollection.name}}</span>
          <span>{{$store.state.discovery.documentSearchCollection.searchInfo}}</span> 
        </span>
        <el-table
          :data="$store.state.discovery.documentSearchCollection.dataList"
          class="result discovery_search"
          :show-header="false"
          :empty-text="$store.state.sysInit.html_const.cons_219_no_data"
          v-loading="$store.state.discovery.documentSearchCollection.loading"
          height="100%"
          @row-dblclick="
            (row, column, e) => documentClick(row, column, e, documentSearchCollection)
          "
          :cell-class-name="rowClass"
        >
          <el-table-column align="center" width="20">
            <template slot-scope="scope">
              <span :class="{ 'show-class': !scope.row.pinFlag }"
                ><img class="img" src="./../assets/img/pin.png"
              /></span>
            </template>
          </el-table-column>
          <el-table-column class-name="title">
            <template slot-scope="scope">
              <div style="margin-top: 5px !important"></div>
              <div>
                <a style="font-weight: 700;color: #039be5;" @click="webLinkClick(scope.row)">{{ scope.row.title}}</a>
                <div :id="scope.row.document_id"
                  :class="[scope.row.notesDocFlg ? 'notesdoc-tip' : (scope.row.showAllflag ? 'notesdoc_disable': 'notesdoc')]">
                  <p v-html="scope.row.text"></p>
                </div>
                
                <el-button
                  type="text"
                  v-if="scope.row.notesDocFlg"
                  @click="changeDoc(scope.row, false)"
                  class="show_all"
                  >一部を表示</el-button
                >
                <el-button
                  v-show="!scope.row.showAllflag"
                  id="showAll"
                  type="text"
                  v-else
                  @click="changeDoc(scope.row, true)"
                  :class="[
                    scope.row.showAllflag ? 'disable_show_all' : 'show_all',
                  ]"
                  :disabled="scope.row.showAllflag"
                  >すべて表示</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="170">
            <template slot-scope="scope">
              <p>
                {{ $store.state.sysInit.html_const.cons_247_score }}
              </p>
              <p
                style="background-color: transparent; border: 0"
                :disabled="judgeLine(scope.row)"
              ></p>
              <div class="score-block">
                <div class="score-div">
                  <span>{{ getConfidenceForDS($store.state.discovery.documentSearchCollection.dataList, scope.row.confidence) }}%</span>
                </div>
                <div class="score-progress">
                  <div class="score-full-div" 
                    :style="{ 'width' : getConfidenceForDS($store.state.discovery.documentSearchCollection.dataList, scope.row.confidence) + '%' }"></div>
                </div>
              </div>
              <p>
                <el-button
                  type="success"
                  :disabled="scope.row.evaluate"
                  @click="evaluate(scope.row, $store.state.discovery.documentSearchCollection, 'good', 'WS')"
                  class="rate is-circle"
                  :class="{ hideEvaluate: scope.row.flag == 'bad' }"
                  icon="good"
                  @click.stop="deleteVisible = true"
                >
                </el-button>
                <el-button
                  type="danger"
                  :disabled="scope.row.evaluate"
                  @click="evaluate(scope.row, collection, 'bad', 'WS')"
                  class="rate is-circle"
                  :class="{ hideEvaluate: scope.row.flag == 'good' }"
                  icon="bad"
                  @click.stop="deleteVisible = true"
                >
                </el-button>
                <span>
                  <el-button
                    v-if="scope.row.saveFlg"
                    class="rate is-circle btn-trans"
                    :disabled="scope.row.saveFlg"
                    :class="{'no-click':scope.row.saveFlg }"
                    >
                    <i class="el-icon-dis-save-before i-trans "/>
                  </el-button>

                  <el-button
                  v-else
                  class="rate is-circle btn-trans"
                  @click="disSave(scope.row, 'WS')"
                  >
                
                    <i class="el-icon-dis-save-before i-trans"/>
                  </el-button>
                </span>
                
                <span v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'">
                  <el-button
                    v-if="scope.row.copyFlg"
                    class="rate is-circle btn-trans"
                    :disabled="scope.row.copyFlg"
                    :class="{'no-click':scope.row.copyFlg }"
                    >
                    <i class="el-icon-dis-copy-before i-trans"/>
                  </el-button>

                  <el-button
                    v-else
                    class="rate is-circle btn-trans"
                    @click="disCopy(scope.row, 'WS')"
                    >
                    <i class="el-icon-dis-copy-before i-trans"/>
                  </el-button>
                </span>             
              </p>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane> -->
       <div :class="[this.$store.state.sysInit.personalSingleMode == 'STAND_MIC_MODE'?'footer-box_f2f':(this.$store.state.sysInit.personalSingleMode == 'NEXMO_ASTERISK_PBX_MODE'?'footer-box_phone':'footer-box_chat')]" >
        <div class="footer-box2">
           <NavigationText></NavigationText>
        </div>

      </div>
     
      <ImgDialog 
        :imgDialogVisible="imgDialogVisible"
        :imgSrc="imgSrc"
        @closeImgDialog="closeImgDialog"/>
       
    </el-tabs>
  </el-main>
</template>

<script>
import { mapGetters } from "vuex";
import NavigationText from './NavigationText.vue';
import OpenAiTab from './OpenAiTab.vue';
import moment from 'moment';
import ImgDialog from './ImgDialog.vue';
export default {
  components: {
    NavigationText,
    OpenAiTab,
    ImgDialog
  },
  props: {
  },
  data() {
    return {
      rating: 0,
      collectionsData: this.$store.state.discovery.collections,
      actTab: 0,
      imgDialogVisible: false,
      imgSrc: ''
    };
  },

  watch: {
   
  },
  computed: {
    ...mapGetters("discovery", {
      collections: "getCollections",
    }),
    ...mapGetters("redmine", {
      issue_id: "getIssueId",
    }),
    ...mapGetters("discovery", {
      default: "getDisDefault",
    }),
    ...mapGetters("discovery", {
      search_flag: "getSearchFlag",
    }),
    azureOpenAiSearchStatus(){
      if(this.$store.state.openAi.searchLoading){
        return '（' + this.$store.state.sysInit.html_const.cons_253_search_text +'）'
      }else if ((this.$store.state.openAi.serviceRequests.length + this.$store.state.openAi.solutions.length)== 0){
        return ''
      }else{
        return '（1）'
      }
    }
  },
  created: function() {},
 
  mounted(){
    window.openImg = (event) => {
      this.imgDialogVisible = true;
      if(event && event.target && event.target.currentSrc){
        this.imgSrc = event.target.currentSrc;
      }
    }
  },
  methods: {
    closeImgDialog(val){
      this.imgDialogVisible = val;
      this.imgSrc = '';
    },
    getHighlightTextHtml(str, key, highlight){
      let hightxt = str;
      if(Object.keys(highlight).indexOf(key) > -1){
        let _t = highlight[key][0]; 
        let origin = _t.replaceAll('<em>','').replaceAll('</em>','');
        let startIndex  = str.indexOf(origin);
        let _current = _t.replaceAll('<em>','<span style="background-color: yellow">').replaceAll('</em>','</span>');
        if(startIndex > -1){
          hightxt = str.slice(0, startIndex) + _current + str.slice(startIndex + origin.length);
        }
      } 
      return hightxt;
    },
    getConfidence(dataList, confidence) {
      let allConfidenceList = dataList.map(item => item.result_metadata.confidence || 0);
      let max = Math.max(...allConfidenceList);
      let maxComputedConfidence = (40 * max) + 60;
      return Math.round(confidence / max * (maxComputedConfidence - 40) + 40);
    },
    getConfidenceForDS(dataList, confidence) {
      let allConfidenceList = dataList.map(item => item.confidence || 0);
      let max = Math.max(...allConfidenceList);
      let maxComputedConfidence = (40 * max) + 60;
      return Math.round(confidence / max * (maxComputedConfidence - 40) + 40);
    },
    resetTab(){
      this.actTab = '0'
    },
    judgeLine(item) {
      let id = item.document_id;
      this.$nextTick(() => {
        let ele = document.getElementById(id);
        // console.log(ele);
        let scrollHeight = ele.scrollHeight;
        let clientHeight = ele.clientHeight;
        // console.log(id);
        // console.log("id,scrollHeight", ele.scrollHeight);
        // console.log("id,clientHeight", ele.clientHeight);
        if (scrollHeight <= 60) {
          // console.log("true");
          item.showAllflag = true;
          // item.notesDocFlg = false;
          // return true;
        } else {
          // console.log("false");
          item.showAllflag = false;
          // item.notesDocFlg = notesDocFlg;
          // return false;
        }
      });
    },
    changeDoc(item, notesDocFlg) {
      item.notesDocFlg = notesDocFlg;
      console.log(item);
    },
    evaluate(doc, collection, flag, collectionFlag) {
      console.log(doc);
      doc.evaluate = true;
      doc.flag = flag;
      doc.score = 10;
      let evaluateFlag = "";
      if (flag == "good") {
        evaluateFlag = "G";
        doc.score = 10;
        let keywordRate = this.$store.state.sysInit.keywordRate;
        if(collectionFlag == 'KRT'){
          var params = {
            document_id: doc.data.notesdocid,
            queryNote: this.$store.state.sysInit.query_note,
            keywordRate: keywordRate,
            notesitem: doc.data.notesitem,
            text: doc.data.notestitle,
          };
        }
        if(collectionFlag == 'Maximo'){
          var params = {
            document_id: doc.id,
            queryNote: this.$store.state.sysInit.query_note,
            keywordRate: keywordRate,
            notesitem: doc.title,
            text: doc.title,
          };
        }
        if(collectionFlag == 'WS'){
          var params = {
            document_id: doc.document_id,
            queryNote: this.$store.state.sysInit.query_note,
            keywordRate: keywordRate,
            notesitem: doc.title,
            text: doc.title,
          };
        }
        
        this.$store.dispatch("discovery/markdoc", params);
      } else {
        evaluateFlag = "B";
        doc.score = 0;
      }
      // this.$store.commit("sysInit/changeNavigationText", "この会話の流れにおけるナレッジの関連度を評価しました");
      this.$store.commit(
        "sysInit/changeNavigationText",
        this.$store.state.sysInit.html_const.cons_241_footer_evaluate_button
      );
      let data;
      if(collectionFlag == 'KRT'){
        data = {
          evaluateFlag: evaluateFlag,
          document_id: doc.data.notesdocid,
          natural_language_query: this.$store.state.sysInit.query_note,
          score: doc.score,
          collection_id: collection.collection_id,
          collection_name: collection.name,
          default: this.default,
          request_id: this.issue_id,
          search_flag: this.search_flag,
          issue_id: this.issue_id,
          text: doc.data.notestitle,
        };
      }
      if(collectionFlag == 'Maximo'){
        data = {
          evaluateFlag: evaluateFlag,
          document_id: doc.document_id,
          natural_language_query: this.$store.state.sysInit.query_note,
          score: doc.score,
          collection_id: collection.collection_id,
          collection_name: collection.name,
          default: this.default,
          request_id: this.issue_id,
          search_flag: this.search_flag,
          issue_id: this.issue_id,
          text: doc.title,
        };
      }
      if(collectionFlag == 'WS'){
        data = {
          evaluateFlag: evaluateFlag,
          document_id: doc.document_id,
          natural_language_query: this.$store.state.sysInit.query_note,
          score: doc.score,
          collection_id: this.$store.state.discovery.documentSearchCollection.collection_id,
          collection_name: this.$store.state.discovery.documentSearchCollection.name,
          default: this.default,
          request_id: this.issue_id,
          search_flag: this.search_flag,
          issue_id: this.issue_id,
          text: doc.title,
        };
      }
      console.log("evaliuate", data);
      this.$store.dispatch("discovery/evaluate", data);
    },
    disSave(doc,collectionFlag){
      doc.saveFlg = true;
      let params;
      if(collectionFlag == 'KRT'){
        params = {
          knowledge_id:doc.data.notesdocid,
          request_times:1,
          update_time:moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
          updated_by:this.$store.state.sysInit.user_id,
          process_status:'0'
        }
      }
      if(collectionFlag == 'Maximo'){
        params = {
          knowledge_id:doc.id,
          request_times:1,
          update_time:moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
          updated_by:this.$store.state.sysInit.user_id,
          process_status:'0'
        }
      }
      if(collectionFlag == 'WS'){
        params = {
          knowledge_id:doc.document_id,
          request_times:1,
          update_time:moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
          updated_by:this.$store.state.sysInit.user_id,
          process_status:'0'
        }
      }
      
      // disRequestListSaveInfo
      this.$store.dispatch("discovery/disRequestListSaveInfo", params);
    },
    webLinkClick(item){
      window.open(item.url);
    },
    linkClick2(item, type){
      let _type = type.toLowerCase();
      _type = _type == 'solution' ? _type : 'plusgsr';
      window.open('https://sno1.manage.inst1.apps.mas.sswjp.net/maximo/oslc/graphite/manage-shell/index.html?event=loadapp&value=' + 
      _type + "&uniqueid=" + item.uid);
    },
    linkClick(item) {
      if (item.data.hasOwnProperty('noteslink') && item.data.noteslink) {
        if(item.data.noteslink.toString().indexOf('http')>-1){
          window.open(item.data.noteslink);
        } else{
          window.open(process.env.VUE_APP_REDMINE_URL + item.data.noteslink);
        }
        this.$store.commit(
          "sysInit/changeNavigationText",
          this.$store.state.sysInit.html_const.cons_242_footer_document_click
        );
        let keywordRate = this.$store.state.sysInit.keywordRate;
        var params = {
          document_id: item.data.notesdocid,
          queryNote: this.$store.state.sysInit.query_note,
          keywordRate: keywordRate,
          notesitem: item.data.notesitem,
          text: item.data.notestitle,
        };
        this.$store.dispatch("discovery/markdoc", params);
      }
    },

    disCopy(doc, flag){
      if(this.$store.state.sysInit.chat_current_status == "isChating"){
        doc.copyFlg = true;
        if(flag == 'KRT'){
          if(doc.data.notesdoc){
            this.$store.state.discovery.copyCounter++;
            this.$store.state.discovery.autoCompleteInputText = this.$store.state.discovery.autoCompleteInputText+doc.data.notesdoc;
          }
        }
        if(flag == 'Maximo' || flag == 'WS'){
          if(doc.title){
            this.$store.state.discovery.copyCounter++;
            this.$store.state.discovery.autoCompleteInputText = this.$store.state.discovery.autoCompleteInputText+doc.title;
          }
        }
      }   
    },

    documentClick(row, column, event, collection) {
      this.$store.dispatch("discovery/pin", { collection, document: row });
    },
    rowClass({ row, column, rowIndex, columnIndex }) {
      if (row.pinFlag && columnIndex === 0) {
        return "pushpin";
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
[class*="el-col-"]:not(:first-child) {
  font-size: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

[class*="el-col-"]:last-child {
  background-color: #f1f3f2;
}
.show_all {
  color: #9932cc;
  font-weight: lighter;
}
.disable_show_all {
  color: #8b8989;
  font-weight: lighter;
}


.el-tabs .el-tab-pane {
    height: 92%;
}

.footer-box2{
  background-color: #f5f7fa;
  width: 100%;
  margin-right: 10px;
  margin-left: 10px;
  border: 1px solid #f5f7fa;
  border-radius: 8px;
}

.footer-box_f2f {
  // background-image: linear-gradient(to right, #5aaafa 0%, #41d6c3 100%);
  background-color: #0086B5;
  height: fit-content;
  padding: 8px 0px;
  width: 100%;
  display: flex;
}
.footer-box_phone {
  // background-image: linear-gradient(to right, #5aaafa 0%, #41d6c3 100%);
  background-color: #55BFE7;
  height: fit-content;
  padding: 9px 0px;
  width: 100%;
  display: flex;
}
.footer-box_chat {
  // background-image: linear-gradient(to right, #5aaafa 0%, #41d6c3 100%);
  background-color: #94E3FF;
  height: fit-content;
  padding: 8px 0px;
  width: 100%;
  display: flex;
}


.el-icon-dis-save{
  background: url("../assets/img/dis_save_info.png") center no-repeat;
  //  font-size: 14px;
  background-size: cover;
}

.no-click{
  cursor: no-drop;
  opacity: 0.4;
}

//content中是中文的Unicode编码； font-size:图标大小； visibility: hidden;来隐藏文字
.el-icon-dis-save:before{
  content: "替";
    font-size: 16px;
    visibility: hidden;
}

.el-icon-dis-save-before{
  background: url("../assets/img/knowledge_save.png") center no-repeat;
  //  font-size: 14px;
  background-size: cover;
}

.el-icon-dis-save-before:before{
  content: "替";
    font-size: 16px;
    visibility: hidden;
}

.el-icon-dis-copy{
  background: url("../assets/img/copy_close.png") center no-repeat;
  //  font-size: 14px;
  // background-size: cover;
  background-size: 150% 150%;
  border-radius: 50%;
}

//content中是中文的Unicode编码； font-size:图标大小； visibility: hidden;来隐藏文字
.el-icon-dis-copy:before{
  content: "替";
    font-size: 16px;
    visibility: hidden;
}

.el-icon-dis-copy-before{
  background: url("../assets/img/copy_open.png") center no-repeat;
  //  font-size: 14px;
  // background-size: cover;
  background-size: 150% 150%;
  border-radius: 50%;
}

.el-icon-dis-copy-before:before{
  content: "替";
    font-size: 16px;
    visibility: hidden;
}

.btn-trans{
  background: transparent!important;
  border: none!important;
}
.i-trans{
  position: relative;
  top: -5px;
  right: -5px;
  height: 28px;
  width:28px;
}

.score-block{
  display: flex;
  align-items: center;
  padding:15px 0;
  width:100%
}

.score-div{
  width:30%;
}

.score-progress{
  height:12px;
  width:60%;
  background-color: white;
  border-radius:5px;
  border:1px solid lightgrey
}

.score-full-div{
  height:10px;
  background-color: #4D96EC;
  border-radius:5px;
}
.icon_openai {
  width: 16px;
  height: 16px;
  margin-right:4px;
  color: #909399;
}
.icon_openai_margin {
  margin-top:-2px
}
</style>
